import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeepdiveRoutingModule } from './deepdive-routing.module';
import { DeepdiveComponent } from './deepdive.component';
import { DxButtonModule, DxChartModule, DxDataGridModule, DxDropDownButtonModule, DxLoadPanelModule, DxPopupModule, DxRangeSelectorModule, DxScrollViewModule, DxSwitchModule, DxTextAreaModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SharedModule } from 'src/app/pipes/shared-module';
import { TaskListPopupModule } from '../../task/task-list-popup/task-list-popup.module';
import { TaskPopupModule } from '../../task/task-popup/task-popup.module';
import { InfoHeaderModule } from 'src/app/widgets/info-header/info-header.module';
import { FormsModule } from '@angular/forms';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { ContainerComponent } from 'src/app/components/container/container.component';


@NgModule({
	declarations: [DeepdiveComponent],
	imports: [
		CommonModule,

		DxTableControllerDirective,

		JumpToModule,
		ContainerComponent,

		DeepdiveRoutingModule, DxChartModule,
		DxDropDownButtonModule,
		DxTextAreaModule, DxRangeSelectorModule,
		DxDataGridModule, DxSwitchModule,
		DevEpressCommonModule, SharedModule,
		DxButtonModule, DxPopupModule, TaskPopupModule, TaskListPopupModule, InfoHeaderModule,
		DxScrollViewModule, DxLoadPanelModule, FormsModule, BookmarkModule
	]
})
export class DeepdiveModule { }

